<template>
  <div class="modal-alpaclass">
    <hr />
    <div class="row">
      <div class="col-lg-6">
        <bp-select
          v-model="form.product_id"
          id="product-select"
          label="Nome do produto"
          class="mb-3"
          placeholder="Selecionar produto"
          :disabled="isEdit"
          :errors="errors.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
          required
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.description"
          id="description"
          label="Descrição da integração (Opcional)"
          placeholder="Digite a descrição da integração"
          :errors="errors.description"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.token"
          id="token"
          label="Token"
          placeholder="Digite o token da integração"
          :errors="errors.token"
          required
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          label="ID da entrega (API)"
          id="delivery-id"
          type="number"
          v-model="form.delivery_id"
          :errors="errors.delivery_id"
          placeholder="Digite o id"
          required
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["description", "delivery_id", "product_id", "status", "token", "name"],
        {
          name: "alpaclass",
          ...this.integrationToEdit
        }
      )
    };
  },
  computed: {
    isValid() {
      return this.form.delivery_id && this.form.product_id && this.form.token;
    }
  }
};
</script>
